export const TIPO_SIM_NAO_ENUM = [
    {
        id: 'S',
        descricao: "Sim",
    },
    {
        id: 'N',
        descricao: "Não",
    },
];